module.exports = __webpack_public_path__ + "b04af257686463aa3347fcb33fb6a6aa.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-tshirt-black-design-resized.png
// module id = 807
// module chunks = 0